"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.primary = exports.inverse = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area,
    isInFocusInverse = ui_blocks_1.INTERACTIVE.isInFocusInverse;
exports.inverse = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  --color-comp-link-text: ", ";\n  &:hover,\n  &:active,\n  &:visited {\n    --color-comp-link-text: ", ";\n  }\n  &:disabled,\n  &[aria-disabled='true'] {\n    --color-comp-link-text: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n  &:focus-visible {\n    ", "\n  }\n"], ["\n  --color-comp-link-text: ", ";\n  &:hover,\n  &:active,\n  &:visited {\n    --color-comp-link-text: ", ";\n  }\n  &:disabled,\n  &[aria-disabled='true'] {\n    --color-comp-link-text: ", ";\n  }\n\n  &:focus {\n    ", "\n  }\n  &:focus-visible {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"600\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"400\"]", theme);
}, isInFocusInverse, isInFocusInverse);
exports.primary = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  --color-comp-link-text: ", ";\n  &:hover,\n  &:active,\n  &:visited {\n    --color-comp-link-text: ", ";\n  }\n  &:disabled,\n  &[aria-disabled='true'] {\n    --color-comp-link-text: ", ";\n  }\n"], ["\n  --color-comp-link-text: ", ";\n  &:hover,\n  &:active,\n  &:visited {\n    --color-comp-link-text: ", ";\n  }\n  &:disabled,\n  &[aria-disabled='true'] {\n    --color-comp-link-text: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.UTILITY.ACTION", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.BLUE[\"600\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"600\"]", theme);
});
exports.Root = styled_components_1.default.a.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['pattern', 'hasUnderline'].includes(prop) && defaultValidatorFn(prop);
  }
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  transition-duration: 0s;\n  background: var(--color-comp-link-surface, transparent);\n  color: var(--color-comp-link-text);\n  &:hover {\n    color: var(--color-comp-link-text);\n  }\n  & ", " {\n    align-self: center;\n    & svg {\n      color: var(--color-comp-link-text);\n    }\n  }\n  ", " & {\n    align-items: baseline;\n  }\n  ", "\n"], ["\n  ", "\n  ", "\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  transition-duration: 0s;\n  background: var(--color-comp-link-surface, transparent);\n  color: var(--color-comp-link-text);\n  &:hover {\n    color: var(--color-comp-link-text);\n  }\n  & ", " {\n    align-self: center;\n    & svg {\n      color: var(--color-comp-link-text);\n    }\n  }\n  ", " & {\n    align-items: baseline;\n  }\n  ", "\n"])), area, function (props) {
  return props.pattern === 'inverse' ? exports.inverse : exports.primary;
}, ui_icon_1.Icon, ui_text_1.Text, function (props) {
  return props.hasUnderline ? 'text-decoration: underline;' : '';
});
var templateObject_1, templateObject_2, templateObject_3;